import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="w-full px-8 bg-neutral-900 text-slate-300">
      {/**container */}

      <div className="mx-auto py-4 max-w-[1000px] flex flex-row items-center justify-between">
        <div className="flex">
          <p>Copyright © 2024. All rights reserved.</p>
        </div>

        <div className="text-slate-300">
          <ul className="flex flex-row">
            <li className="py-4 px-4 flex justify-between items-center hover:text-yellow-400 duration-300">
              <a
                className="items-center w-full"
                href="https://www.linkedin.com/in/seahjinhan/"
              >
                <FaLinkedin size={30} />
              </a>
            </li>
            <li className="py-4 px-4 flex justify-between items-center hover:text-yellow-400 duration300">
              <a
                className="items-center w-full"
                href="https://github.com/sjhmichael"
              >
                <FaGithub size={30} />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
